<div>
  <nx-pageTitle-box
    [label]="
      'Vorlage für ' +
      (this.formName ? this.formName : '-') +
      (this.id ? ' bearbeiten' : ' anlegen')
    "
    [bcRootLvlLabel]="'Formulare'"
    [bcRootLvlPath]="'settings/forms'"
    [icon]="'icon-documents'"
    [iconToolTip]=""
  ></nx-pageTitle-box>
  <div class="body flex flex-col white">
    <div
      [formGroup]="variantFormGroup"
      class="form flex flex-col gap-25 basis-full border-b"
    >
      <nx-edit-text-input formControlName="name" [label]="'Name'">
      </nx-edit-text-input>
      <p-checkbox
        class="mb-3"
        [binary]="true"
        formControlName="isActive"
        [disabled]="formVariant?.isActive"
        label="Aktiv"
        labelStyleClass="ml-2"
      ></p-checkbox>
      <!-- <ngs-code-editor [theme]="theme" [codeModel]="codeModel" [options]="options" (valueChanged)="onCodeChanged($event)" class="border">
    </ngs-code-editor> -->
      <ace
        [mode]="'json'"
        class="editor"
        id="editor1"
        [theme]="'github'"
        [(value)]="codeValue"
        (textChanged)="onCodeChanged($event)"
        #editor
      ></ace>

      <!-- <hr> -->
    </div>
    <div class="basis-full flex flex-row gap-2 items-start mt-5">
      <nx-default-button
        class="confirm"
        label="Speichern"
        [disabled]="!(variantFormGroup?.valid && !variantFormGroup?.pristine)"
        (click)="saveFormVariant()"
      >
      </nx-default-button>
      <nx-default-button class="reject" label="Abbrechen" (click)="abort()">
      </nx-default-button>
    </div>
  </div>
</div>
